import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { useTraderRoomRoutesConditions } from '@pages/Traders-Room/TradersRoom.routes'

import { useSessionEntity } from '@context/EntityContext'

import { FilesIcon } from '@ui/icons/Files.icon'

import { useGAEvents } from '@utils/callGAEvents'
import { TickmillCompaniesEnum } from '@utils/companyName.utils'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection } from '../useMenuSections'

export const useSocialTradingMenu = (): MenuSection => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const { isTradersRoomVisible } = useTraderRoomRoutesConditions()
  const entity = useSessionEntity()
  const { callGAEvents } = useGAEvents()

  return useMemo(
    () => ({
      id: 'social-trading',
      label: t('Tabs.Social Trading'),
      icon: FilesIcon,
      onClick: () => {
        callGAEvents().SocialTradingPage.Links.menuTab()
        navigate('/dashboard/social-trading')
      },
      condition: isTradersRoomVisible && entity === TickmillCompaniesEnum.TICKMILL_SC,
      products: [TickmillProductType.CFD],
    }),
    [t, isTradersRoomVisible, entity, callGAEvents, navigate]
  )
}
